<template>
  <div>
    <CRow class="content-fade-in" ref="container">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="12" md="12" xl="12">
                  <BaseInput
                    :options="titleInput.options"
                    :data="titleInput.data"
                    :listener="titleInput.listener"
                  />
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <div class="form-input-wrapper">
                    <div class="form-group">
                      <label class="form-label" for="uploadFile">Chọn file <span class="required">*</span> (.mp3, .wav)</label>
                      <div class="custom-file"
                           :class="selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                        <input type="file" class="custom-file-input" id="uploadFile" ref="file" accept=".mp3, .wav"
                               multiple @change="selectFile($event)">
                        <label class="custom-file-label" for="uploadFile">Chọn tệp</label>
                      </div>
                      <span class="valid-error">{{ selectedFiles.data.validator.errorMessage }}</span>
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="12" class="mt-4">
                  <CDataTable
                    :items="selectedFiles.data.model"
                    :fields="chooseFileTable.options.fields"
                    :sorterValue="{ column: null, asc: 'true' }"
                  >
                    <template #name="{item}">
                      <td>{{ item.fileName }}</td>
                    </template>
                    <template #url="{item}">
                      <td>
                        <audio controls aria-label="Tệp chuyển đổi" class="audio-css" :ref="item.urlBlob"
                               style="width: 80%">
                          <source :src="item.urlBlob" type="audio/mpeg">
                          <source :src="item.urlBlob" type="audio/wav">
                        </audio>
                      </td>
                    </template>
                    <template #size="{item}">
                      <td>
                        {{ (item.size / (1024 * 1024)).toFixed(2) }}
                      </td>
                    </template>
                    <template #action="{item, index}">
                      <td class="action-btn-group">
                        <div class="action-btn-wrapper">
                          <CButton color="info"
                                   variant="outline"
                                   v-c-tooltip.hover="'Lên vị trí'"
                                   square
                                   size="sm"
                                   :disabled="index === 0"
                                   @click="changeIndexFile(index, 'up')">
                            <CIcon name="cil-arrow-top"/>
                          </CButton>
                          <CButton
                            color="info"
                            variant="outline"
                            class="ml-1"
                            square
                            size="sm"
                            :disabled="index === selectedFiles.data.model.length - 1"
                            @click="changeIndexFile(index, 'down')"
                            v-c-tooltip.hover="'Xuống vị trí'">
                            <CIcon name="cil-arrow-bottom"/>
                          </CButton>
                          <CButton
                            color="danger"
                            variant="outline"
                            class="ml-1"
                            square
                            size="sm"
                            @click="deleteFile(index)"
                            v-c-tooltip.hover="'Xóa'">
                            <CIcon name="cil-trash"/>
                          </CButton>
                        </div>
                      </td>
                    </template>
                    <template slot="no-items-view">
                      <span style="color:#969696;">Danh sách trống!</span>
                    </template>
                    <template slot="loading">
                      <BaseLoading :loading="loading"/>
                    </template>
                  </CDataTable>
                </CCol>
              </CRow>
              <CRow>
                <CCol style="display: inline-flex;align-items: center" v-show="fileMergeResult">
                  <audio controls aria-label="Tệp chuyển đổi" ref="resultFile" class="audio-css">
                    <source :src="fileMergeResult.path" type="audio/mpeg">
                    <source :src="fileMergeResult.path" type="audio/wav">
                  </audio>
                  <CButton color="success" class="btn-action-primary ml-2"
                           @click="downloadByUrl()"><i class="fa fa-download"></i> Tải xuống
                  </CButton>
                  <CButton color="primary" class="btn-action-primary ml-2" @click="clickAddFile()"><i
                    class="fa fa-file"></i> Biên tập
                  </CButton>
                </CCol>
              </CRow>
              <br/>
              <CRow>
                <CCol sm="6" md="6">
                  <CButton
                    color="primary"
                    class="btn-action-primary mr-2"
                    @click="submitData"
                  >
                    <i class="fa fa-code-fork"></i> Xử lý ghép file
                  </CButton>
                  <CButton
                    color="secondary"
                    class="btn-action-primary mr-2"
                    @click="resetData()"
                  ><i class="fa fa-eraser"></i> Làm mới
                  </CButton>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
        <BaseAudioAddFile v-if="isShowFileAdd" :file="fileAddContent" :duration="durationFileAdd" :sourceType="sourceType"
                          @loading="loadingAdd($event)"></BaseAudioAddFile>
      </CCol>
      <BaseLoading :loading="loading.value"></BaseLoading>
    </CRow>
  </div>
</template>

<script>
import BaseInput from "../../base/BaseInput";
import BaseLoading from "../../base/BaseFormLoading";
import {FILE_MERGE_MAX_SIZE} from "@/constant";
import BaseAudioAddFile from "@/views/base/AudioAddFile";
import {sourceType} from "../../../constant";

export default {
  name: "MergeFile",
  components: {BaseAudioAddFile, BaseInput, BaseLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      sourceType: sourceType.GHEP_TEP,
      fileAddContent: {
        fileName: '',
        content: ''
      },
      durationFileAdd: '',
      isShowFileAdd: false,
      fileMergeResult: '',
      titleInput: {
        options: {
          label: "Tên tệp tin <span class='required'>*</span>",
          placeholder: "Tên tệp tin",
          type: "text"
        },
        data: {
          name: "title",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên tệp tin không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      selectedFiles: {
        data: {
          name: "files",
          model: [],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.selectedFiles.data.model;
              if (value.length == 0) {
                this.isValid = false;
                this.errorMessage = "File không được để trống";
              } else if (value.length == 1) {
                this.isValid = false;
                this.errorMessage = "Tối thiểu phải 2 file";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        },
      },
      chooseFileTable: {
        options: {
          fields: [
            {key: "name", label: "Tên", _style: 'width: 40%;'},
            {key: "url", label: "File", _style: 'width: 30%;'},
            {key: "size", label: "Dung lượng (Mb)", _style: 'width: 10%;'},
            {key: "action", label: "Thao tác", _style: 'width: 10%;'}
          ],
          slots: ["index", "name", "size", "url", "action"],
        },
      },
      fileRequest: []
    };
  },
  methods: {
    async selectFile(event) {
      let that = this;
      if (event.target.files.length > 0) {
        this.loading.value = true;
        if (this.selectedFiles.data.model.length < 10) {
          Promise.all(
            (function* () {
              let _that = that;
              for (let file of event.target.files) {
                yield new Promise(resolve => {
                  let reader = new FileReader();
                  reader.onload = () => {
                    let data = {
                      fileName: file.name,
                      type: file.type,
                      size: file.size,
                      urlBlob: _that.convertBlob(reader.result)
                    }
                    resolve(data)
                  };
                  reader.readAsDataURL(file);
                })
                that.fileRequest.push(file)
              }
            })())
            .then(texts => {
              texts.map(each => {
                if (this.validateFile(each)) {
                  this.selectedFiles.data.model.push(each)
                }
              })
              setTimeout(() => {
                that.loading.value = false
              }, 300)
            }).catch(error => {
              that.loading.value = false;
              console.log(error);
            }
          );
        } else {
          this.showWarningMsg({message: "Xử lý tối đa 10 file"})
          this.loading.value = false;
        }
      }
    },
    validateFile(file) {
      if (this.selectedFiles.data.model.length >= 10) {
        return false;
      } else {
        if (file && file.type !== 'audio/wav' && file.type !== 'audio/mpeg') {
          return false;
        }
        return true;
      }
    },
    validateSizeFile() {
      if (this.selectedFiles.data.model.length > 0) {
        let totalSize = this.selectedFiles.data.model.map(each => each.size).reduce((a, b) => a + b);
        if (totalSize > FILE_MERGE_MAX_SIZE) {
          this.selectedFiles.data.validator.isValid = false;
          this.selectedFiles.data.validator.errorMessage = "Tổng file không quá 150Mb";
          return false;
        }
        return true;
      }
    },
    convertDataURIToBinary(dataURI) {
      let BASE64_MARKER = ';base64,';
      let base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
      let base64 = dataURI.substring(base64Index);
      let raw = window.atob(base64);
      let rawLength = raw.length;
      let array = new Uint8Array(new ArrayBuffer(rawLength));
      for (let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
      return array;
    },
    convertBlob(data) {
      let binary = this.convertDataURIToBinary(data);
      let blob = new Blob([binary], {type: 'audio/wav'});
      return URL.createObjectURL(blob);
    },
    changeIndexFile(index, type) {
      this.loading.value = true;
      if (type == 'up') {
        this.arrayMove(index, index - 1);
      } else if (type == 'down') {
        this.arrayMove(index, index + 1);
      }
    },
    async deleteFile(index) {
      let that = this;
      this.loading.value = true;
      this.selectedFiles.data.model.splice(index, 1);
      this.fileRequest.splice(index, 1);
      setTimeout(() => {
        this.reloadAudio(that.selectedFiles.data.model).then(result => {
          that.loading.value = false;
        });
      }, 100)
    },
    async reloadAudio(files) {
      const promise = await new Promise((resolve) => {
        files.map(each => this.$refs[each.urlBlob].load());
        resolve(files)
      })
      return promise;
    },
    async arrayMove(old_index, new_index) {
      let data = [this.selectedFiles.data.model, this.fileRequest];
      Promise.all(
        (function* () {
          for (let each of data) {
            yield new Promise(resolve => {
              if (new_index >= each.length) {
                let k = new_index - each.length + 1;
                while (k--) {
                  each.push(undefined);
                }
              }
              each.splice(new_index, 0, each.splice(old_index, 1)[0]);
              resolve(each)
            })
          }
        })())
        .then(() => {
          this.reloadAudio(this.selectedFiles.data.model)
          setTimeout(() => {
            this.loading.value = false;
          }, 100)
        }).catch(error => {
        console.log(error);
      })
    },
    async downloadByUrl() {
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.href = this.fileMergeResult.path
      a.download = this.fileMergeResult.fileName
      a.click()
    },
    resetData() {
      this.titleInput.data.model = '';
      this.selectedFiles.data.model = [];
      this.fileRequest = [];
      this.fileMergeResult = '';
      this.isShowFileAdd = false;
      this.fileAddContent.fileName = '';
      this.fileAddContent.content = '';
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.titleInput.data.validator.valid();
      isValid &= this.selectedFiles.data.validator.valid();
      isValid &= this.validateSizeFile();
      if (!isValid) {
        return;
      }
      this.loading.value = true;

      let formData = new FormData();
      formData.append("title", this.titleInput.data.model);
      for (let each of this.fileRequest) {
        formData.append("files", each);
      }
      that.$helper.loadDataSource({
        url: "/audio-file/merge-file",
        dataSubmit: function () {
          return formData;
        },
        isMultiPartFormData: true,
        successCallback: async function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            const blob = await that.$helper.fetchToBlob(response.data.data.path)
            let url = URL.createObjectURL(blob)
            that.fileMergeResult = {
              path: url,
              fileName: response.data.data.fileName
            };
            that.$refs.resultFile.load();
            that.showSuccessMsg({message: "Ghép file thành công"});

            let base64 = await that.$helper.blobToBase64(blob);
            that.fileAddContent.content = base64;
            that.fileAddContent.fileName = that.titleInput.data.model + ".mp3";

            var audio = document.createElement('audio');
            audio.src = url;
            audio.addEventListener('loadedmetadata', function () {
              var duration = new Date(audio.duration * 1000).toISOString().substr(11, 8);
              that.durationFileAdd = duration;
            }, false);
          }
          that.loading.value = false
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },
    clickAddFile() {
      let that = this;
      this.isShowFileAdd = true;
      setTimeout(() => {
        let container = that.$refs.container;
        window.scrollTo({left: 100, top: container.scrollHeight, behavior: "smooth"});
      }, 200);
    },
    loadingAdd(value) {
      if (value) {
        this.loading.value = true;
      } else {
        this.loading.value = false;
      }
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {}
};
</script>
